import { getUser } from "@braze/web-sdk";
import { store } from "../../redux/store";
import { isBrazeReady } from "./brazeReady";

export const filterContentCards  = (contentCards, templates = null, storeId = null, currentUrl = null) => {
  const { selectedCountry } = store.getState().country;
  return contentCards?.cards.filter(card => {
    const showCountryIds = (card.extras?.showCountryIds || "")
      .split(',')
      .filter(item => item)
      .map(item => {
        return parseInt(item.trim(), 10);
      })

    const hideCountryIds = (card.extras?.hideCountryIds || "")
      .split(',')
      .filter(item => item)
      .map(item => {
        return parseInt(item.trim(), 10);
      })

    const selectedCountryId = parseInt(selectedCountry.id, 10);
    if (
      showCountryIds.length > 0 &&
      !showCountryIds.includes(selectedCountryId)
    ) {
      return false;
    }

    if (
      hideCountryIds.length > 0 &&
      hideCountryIds.includes(selectedCountryId)
    ) {
      return false;
    }

    const showStoreIds = (card.extras?.showStoreIds || "")
      .split(',')
      .filter(item => item)
      .map(item => {
        return parseInt(item.trim(), 10);
      })

    const hideStoreIds = (card.extras?.hideStoreIds || "")
      .split(',')
      .filter(item => item)
      .map(item => {
        return parseInt(item.trim(), 10);
      })

    const hasShowStoreIds = showStoreIds.length > 0;
    const hasHideStoreIds = hideStoreIds.length > 0;
    const shouldShowForSelectedStore = showStoreIds.includes(storeId);
    const shouldHideForSelectedStore = hideStoreIds.includes(storeId);

    const template = templates.includes(card?.extras?.template);

    if (!template) {
      return false;
    }

    const includePages = (card.extras?.includePages || "").split(',').map(page => page.trim()).filter(page => page);
    const hasIncludePages = includePages.length > 0;
    if (hasIncludePages && currentUrl) {
      const currentUrlPath = currentUrl ? new URL(currentUrl).pathname : null;
      const matchesPage = includePages.some(page => {
        try {
          // Try to parse as URL to get path, fallback to treating as path if parsing fails
          const pageUrl = new URL(page);
          const pagePath = pageUrl.pathname;
          // Special handling for root path
          if (pagePath === '/') {
            return currentUrlPath === '/';
          }
          // For other paths, check if current path starts with the include page path
          return currentUrlPath.startsWith(pagePath);
        } catch {
          // If page is not a valid URL, treat it as a path
          const pageNormalized = page.replace(/\/$/, '');
          if (pageNormalized === '') {
            return currentUrlPath === '/';
          }
          return currentUrlPath.startsWith(pageNormalized);
        }
      });
      if (!matchesPage) {
        return false;
      }
    }

    if (hasShowStoreIds) {
      return shouldShowForSelectedStore;
    }
    if (hasHideStoreIds) {
      return !shouldHideForSelectedStore;
    }

    return true;
  }).sort((a, b) => {
    const aSort = a?.extras?.sort;
    const bSort = b?.extras?.sort;

    if (aSort < bSort)
      return -1;
    if (aSort > bSort)
      return 1;
    return 0;
  })
}

export const sendGeolocationToBraze = () => {
  if (!isBrazeReady()) {
    return;
  }
  navigator.geolocation.getCurrentPosition((position) => {
    if (!isBrazeReady()) {
      return;
    }
    getUser().setLastKnownLocation(
      position.coords.latitude,
      position.coords.longitude,
      position.coords.accuracy,
      position.coords.altitude,
      position.coords.altitudeAccuracy
    );
  });
}
